module.exports = __webpack_public_path__ + "static/media/icon_event_custom.65fb7c8d.svg";